import type { ReactNode } from 'react';
import { useAuth } from '../../lib/auth';
import { Navigate, useLocation } from 'react-router-dom';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();

  if (!isLoaded) {
    return (
      <div className="yd-container py-16" data-testid="auth-loading">
        <div className="yd-skeleton h-8 w-48" />
      </div>
    );
  }
  if (!isSignedIn) {
    return <Navigate to="/giris" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}
